import type { adaptPost } from "./api";

type Post = ReturnType<typeof adaptPost>;
export const SITE_URL = "https://tokamdarius.ca";
export const needsEditorialReview = (author: string) => !author.trim() || author.trim().toLowerCase() === "admin";
export const isDarius = (author: string) => author.trim().toLowerCase() === "tokam darius";
export function validDate(value?: string) {
  if (!value || Number.isNaN(Date.parse(value))) return undefined;
  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : new Date(value).toISOString();
}
export const safeJsonLd = (value: unknown) => JSON.stringify(value).replace(/</g, "\\u003c");

export function articleSchema(post: Post) {
  const url = `${SITE_URL}/blog/${post.slug}`;
  const published = validDate(post.publishedAt);
  const updated = validDate(post.updatedAt);
  // Admin is an account label, not a person or a confirmed reviewer.
  const author = needsEditorialReview(post.author) ? undefined : {
    "@type": "Person", name: post.author,
    ...(isDarius(post.author) ? { url: `${SITE_URL}/a-propos` } : {}),
  };
  return {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "BlogPosting", "@id": `${url}#article`, url,
      mainEntityOfPage: { "@type": "WebPage", "@id": url },
      headline: post.title, description: post.excerpt, inLanguage: "fr-CA",
      ...(post.coverImage ? { image: new URL(post.coverImage, SITE_URL).href } : {}),
      datePublished: published,
      dateModified: updated && (!published || Date.parse(updated) >= Date.parse(published)) ? updated : undefined,
      author,
      publisher: { "@type": "Person", name: "Tokam Darius", url: `${SITE_URL}/a-propos` },
    }, {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: SITE_URL + "/" },
        { "@type": "ListItem", position: 2, name: "Le journal", item: SITE_URL + "/blog" },
        { "@type": "ListItem", position: 3, name: post.title, item: url },
      ],
    }] as const,
  };
}
